import { render } from "./m-edit-code.vue?vue&type=template&id=48ad5128&scoped=true"
import script from "./m-edit-code.vue?vue&type=script&lang=js"
export * from "./m-edit-code.vue?vue&type=script&lang=js"

import "./m-edit-code.vue?vue&type=style&index=0&id=48ad5128&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ad5128"]])

export default __exports__